import Container from '@/components/Container';
import { Typography } from '@mui/material';
import SwitchInput from '@/components/forms/SwitchInput';
import TextInput from '@/components/forms/TextInput';
import React from 'react';

interface TimeProps {
  blockPath: string;
  tComponents: (key: string) => string;
  filterEnabled: boolean;
}

const FilterTime: React.FC<TimeProps> = ({ blockPath, tComponents, filterEnabled }) => (
  <Container fullWidth column right>
    <Container fullWidth>
      <Container fullWidth left>
        <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
          {tComponents('DMFilterSearch.TimeTitleLabel')}
        </Typography>
      </Container>
      <Container fullWidth right>
        <div style={{ width: 'auto' }}>
          <SwitchInput
            path={`${blockPath}.userCanFilterTime`}
            label={tComponents('DMFilterSearch.UserFiltrationOnWebsite')}
          />
        </div>
      </Container>
    </Container>
    <Container fullWidth>
      <TextInput path={`${blockPath}.timeYearFrom`} label={tComponents('DMFilterSearch.TimeYearFrom')} />
      <TextInput path={`${blockPath}.timeYearTo`} label={tComponents('DMFilterSearch.TimeYearTo')} />
      {filterEnabled && (
        <div style={{ width: '40%' }}>
          <TextInput path={`${blockPath}.timeSliderTitle`} label={tComponents('DMFilterSearch.TimeSliderTitle')} />
        </div>
      )}
    </Container>
  </Container>
);

export default FilterTime;
